import { Component, signal } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { AlgorithmFormComponent } from '@app/components/forms/algorithm/form.component';
import { LoadingErrorBlockComponent } from '@app/components/loading-error-block/loading-error-block.component';
import { HeadMetaComponent } from '@app/components/ui.component';
import { AppHttpError } from '@app/interfaces/pg-models.interface';
import { Algorithm, AlgorithmCreate } from '@app/models/algorithm.interface';
import { AlgorithmHelperService } from '@app/services/helpers/algorithm-helper.service';
import { ToastService } from '@app/services/toast.service';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faSave, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { LetDirective } from '@ngrx/component';
import { Observable } from 'rxjs';
import { HelpButtonComponent } from "@app/components/help-button/help-button.component";

@Component({
    selector: 'app-algorithm-edit',
    imports: [
        HeadMetaComponent,
        LetDirective,
        LoadingErrorBlockComponent,
        AlgorithmFormComponent,
        FontAwesomeModule,
        RouterModule,
        HelpButtonComponent
    ],
    templateUrl: './edit.page.html',
    styleUrl: './edit.page.scss'
})
export class AlgorithmEditPage {
  public title = 'Algorithm Edit';
  formValid = signal(false);
  formValue = signal<AlgorithmCreate | null>(null);
  id: number;
  algorithm$: Observable<Algorithm>;

  faSave = faSave;
  faArrowLeft = faArrowLeft;

  constructor(
    private route: ActivatedRoute,
    private algorithmHelper: AlgorithmHelperService,
    private router: Router,
    private toast: ToastService,
  ) {
    this.id = this.route.snapshot.params['id'];
    this.algorithm$ = this.algorithmHelper.getById(this.id);
  }

  update() {
    let val = this.formValue();
    if(val)
      this.algorithmHelper.update(this.id, val).subscribe({
        next: (success) => { this.router.navigate(['algorithms', this.id]); },
        error: (err: AppHttpError) => {
          this.toast.message({ message: err.error.code + ": " + err.error.message, type: 'error'});
        }
      });
  }
}
